module.exports = __webpack_public_path__ + "img/frame4.4d207f67.jpg";